import requestQuestionComponent from './requestQuestion.component';

let requestQuestionModule = angular.module('vacations-absences.requestQuestion', [])

.component('requestQuestion', requestQuestionComponent)

.name;

export default requestQuestionModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestQuestion/requestQuestion.js